module.exports = __webpack_public_path__ + "img/launch-sign.ef47e418.png";